import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cx from 'clsx';
import generateGradientValue from '../generate-gradient-value';
import classes from './GradientPreview.styles.less';
export default function GradientPreview({ values, angle, className, type }) {
    const gradient = generateGradientValue({ angle, values, type });
    return (_jsx("div", { className: cx(classes.preview, className), children: _jsx("div", { className: classes.body, style: { backgroundImage: gradient } }) }));
}
